module.exports = __webpack_public_path__ + "img/collaborate-left-jewelry.d72d8442.svg";